module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Dish-e263572077737d344ee4e84fd9d72b57ca96e5fdde279867e08ba38cabc98b3f.svg";